module.exports = __webpack_public_path__ + "static/media/noImageLH.422da306.jpg";